/* EOFY GWP — auto-add free V-Shape Roller when the V-Shape Home Care Kit is in cart.
   The live BXGY automatic discount zeroes the roller's price; this just ensures it's
   in the cart so the gift is automatic. Defensive: never throws into the storefront. */
(function () {
  var KIT = 50309571510552;
  var ROLLER = 50309758484760;
  var busy = false;

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function addRoller() {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: ROLLER, quantity: 1, properties: { _gift: 'Free with V-Shape Home Care Kit' } }] })
    });
  }
  function removeLine(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
  }
  function refresh() {
    try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
    if (window.location.pathname.indexOf('/cart') === 0) window.location.reload();
  }

  function sync() {
    if (busy) return;
    busy = true;
    getCart().then(function (cart) {
      var hasKit = false, roller = null;
      (cart.items || []).forEach(function (it) {
        var vid = it.variant_id || it.id;
        if (vid === KIT) hasKit = true;
        if (vid === ROLLER) roller = it;
      });
      if (hasKit && !roller) return addRoller().then(refresh);
      // only pull the roller if WE auto-added it (don't remove a deliberately bought one)
      if (!hasKit && roller && roller.properties && roller.properties._gift) return removeLine(roller.key).then(refresh);
    }).catch(function () {}).then(function () { busy = false; });
  }

  // run on load
  if (document.readyState !== 'loading') sync();
  else document.addEventListener('DOMContentLoaded', sync);

  // re-sync after any Ajax cart mutation (covers drawer/quick-add themes)
  var _fetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    return _fetch.apply(this, args).then(function (res) {
      try {
        var url = (args[0] && args[0].url) || args[0];
        if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url) && url.indexOf('/cart.js') < 0) {
          setTimeout(sync, 200);
        }
      } catch (e) {}
      return res;
    });
  };
})();
